import {
  ChangeDetectionStrategy,
  Component,
  inject,
  OnInit,
  input,
  DestroyRef,
  signal,
  computed
} from '@angular/core';
import { Store } from '@ngrx/store';

import { Attachment } from '@ui/shared/model';

import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { distinctUntilChanged, startWith } from 'rxjs/operators';
import { Theme } from '../../../infrastructure/theme/symbols';
import { ThemeService } from '../../../infrastructure/theme/theme.service';
import { ThemeUrls } from '../../../infrastructure/theme/theme-urls';
import { WINDOW_REF } from '../../../infrastructure/browser/window-ref.token';
import { Go } from '../../../infrastructure/base-state/router/router.actions';

@Component({
  selector: 'app-logo',
  templateUrl: './logo.component.html',
  styleUrls: ['./logo.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class LogoComponent implements OnInit {
  #destroyRef = inject(DestroyRef);
  private store = inject(Store);
  private themeService = inject(ThemeService);
  private windowRef = inject(WINDOW_REF);

  readonly url = input('/');
  readonly alternativeUrl = input<string>(undefined);
  readonly preventClick = input<boolean>(undefined);
  readonly landlordLogo = input<Attachment>(undefined);
  readonly tenantInInternalPool = input<boolean>(undefined);
  readonly targetHandling = input('_blank');

  private theme = signal<Theme | undefined>(undefined);
  protected readonly logo = computed(() => {
    const theme = this.theme();
    if (!theme) return undefined;

    return theme.name === ThemeUrls.IMMOMIO && this.tenantInInternalPool()
      ? theme.iTPLogo
      : theme.logo;
  });
  protected readonly logoExist = computed(
    () => !this.logo() && !this.landlordLogo()
  );

  ngOnInit() {
    this.themeService.themeChange
      .pipe(
        startWith(this.themeService.getActiveTheme),
        distinctUntilChanged(),
        takeUntilDestroyed(this.#destroyRef)
      )
      .subscribe(() => {
        this.theme.set(this.themeService.getActiveTheme);
      });
  }

  onClick() {
    if (this.preventClick()) return;
    const url = this.alternativeUrl() || this.theme()?.alternativeUrl;
    if (url) {
      this.windowRef.open(url, this.targetHandling());
    } else {
      this.store.dispatch(
        new Go({
          path: [this.url()]
        })
      );
    }
  }
}
